module.exports = __webpack_public_path__ + "img/icon_equity.6b3f076d.png";